export const NOTIFICATION = {
  // TODO all notification variants
  notificationNegativeBackground: '#5C1D16',
  notificationNegativeText: '#F4AFA7',
  notificationInfoBackground: '#5B36C9',
  notificationInfoText: '#F4AFA7',
};
